import React from "react";
import { useSelector } from "react-redux";
import ErrorPage from "../components/pages/Error";

const ProtectedRoute = ({ children, access = [] }) => {
  const { userType } = useSelector((state) => state.authReducer);

  const hasAccess = access.includes(userType);

  if (!hasAccess) return <ErrorPage status={404} />;

  return <div>{children}</div>;
};

export default ProtectedRoute;
